_ = require('lodash')
$ = require('jquery')

CourseListModalCtrl = ($scope ,$translate ,$filter ,flash , $location ,groupEventService,$ngConfirm, $modalInstance ) ->

  $scope.selectCourse = ->
    $modalInstance.close($scope.filterCourseList)

  $scope.checkCourse = (item) ->
    if item.id == 0 && item.checked == false
      for course in $scope.filterCourseList
        course.checked = false

    if item.id != 0
      for course in $scope.filterCourseList
        if course.id == 0 && course.checked == true
          course.checked = false

    item.checked = !item.checked


CourseListModalCtrl.$inject = [
  '$scope'
  '$translate'
  '$filter'
  'flash'
  '$location'
  'groupEventService'
  '$ngConfirm'
  '$modalInstance'
]

module.exports = CourseListModalCtrl



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/group-event/course-list-modal-controller.coffee